import { IToastConfig } from 'src/common/primitives/Toast';

export function generateMemberEditSuccessToast(
  memberName: string
): IToastConfig {
  return {
    type: 'success',
    title: `${memberName} updated successfully`,
  };
}
